'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _AutoComplete = require('./AutoComplete');

var _AutoComplete2 = _interopRequireDefault(_AutoComplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AutoComplete2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/AutoComplete/index.js
 ** module id = 418
 ** module chunks = 0
 **/